import React from 'react';
import { getBezierPath, type ConnectionLineComponentProps, type Node } from '@xyflow/react';
import type { RuleNodeData } from '../RuleNode';
import { getHandleColor } from '../../utils/handleColors';
import type { HandleType } from '../../types/registry';

/**
 * Custom connection line that matches the source handle's type color
 * while the user drags a new connection.
 */
export function TypedConnectionLine({
  fromX,
  fromY,
  toX,
  toY,
  fromPosition,
  toPosition,
  fromNode,
  fromHandle
}: ConnectionLineComponentProps ) {
  let strokeColor = '#9ca3af';

  if ( fromNode && fromHandle?.id ) {
    const data = ( fromNode as unknown as { data: RuleNodeData }).data;
    const handles = fromHandle.type === 'source' ? data.outputs : data.inputs;
    const matched = handles?.find(( h ) => h.name === fromHandle.id );
    if ( matched ) {
      strokeColor = getHandleColor( matched.type as HandleType );
    }
  }

  const [path] = getBezierPath({
    sourceX: fromX,
    sourceY: fromY,
    targetX: toX,
    targetY: toY,
    sourcePosition: fromPosition,
    targetPosition: toPosition
  });

  return (
    <g>
      <path
        d={path}
        fill="none"
        stroke={strokeColor}
        strokeWidth={2}
        strokeDasharray="5,5"
        className="animated"
      />
      <circle
        cx={toX}
        cy={toY}
        r={4}
        fill={strokeColor}
        stroke={strokeColor}
        strokeWidth={1.5}
      />
    </g>
  );
}
